<head>
  <title i18n="@@Searchia Documentation">Searchia Documentation</title>
</head>
<router-outlet></router-outlet>
